/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PracticeSettings } from '../../models/practice-settings';

export interface AppSettingGetPracticeSettings$Params {
}

export function appSettingGetPracticeSettings(http: HttpClient, rootUrl: string, params?: AppSettingGetPracticeSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<PracticeSettings>> {
  const rb = new RequestBuilder(rootUrl, appSettingGetPracticeSettings.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PracticeSettings>;
    })
  );
}

appSettingGetPracticeSettings.PATH = '/api/AppSetting/PracticeSettings';
